import React from "react";
import { Box, Typography } from "@mui/material";
import GradientButton from "../../../input/GradientButton";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

/**
 * Shown when the user has tasks but all of them are already targeted.
 * Offers a button to create more tasks.
 */
const AllTargetedStep = ({ onCreateMore }) => {
  return (
    <Box className="task-guide-step task-guide-step--all-targeted">
      <AnimatedOrb size="medium" intensity="celebrating" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          All your tasks are already targeted!
        </Typography>
        <Typography
          variant="body2"
          sx={{ margin: 0, mt: 1, textAlign: "center", opacity: 0.8 }}
        >
          You're fully locked in. If you want to add more to your plate, you can
          create a new task.
        </Typography>
      </SpeechBubble>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
        <GradientButton text="Create a new task" onClick={onCreateMore} />
      </Box>
    </Box>
  );
};

export default AllTargetedStep;

